import { render, staticRenderFns } from "./BookingTemplateDetails.vue?vue&type=template&id=1ab810e9&"
import script from "./BookingTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./BookingTemplateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports